var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 58,
    viewBox: "0 0 90 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1422 0.665878H2.72035L1.41705 1.08294L2.40758 2.85545L1.57345 5.46209L3.34596 7.86019L1 15.0024L3.60664 19.2251L4.0237 23.2915L7.51659 29.1825L7.88152 33.8223L10.2796 38.3578L11.0616 44.0403L10.8531 51.4953L13.0948 53.9976L67.1564 53.372L70.3886 57.3341H72.1611L72.0569 53.8934L75.9147 51.8602V49.3057L78.0521 47.2204L77.8957 44.9787L75.654 42.372L76.5924 38.8792L81.7536 37.8365L86.6019 35.5948L86.5498 33.1446L88.1659 31.5806L89 26.3152L85.1943 24.2299L84.9336 21.9882L81.91 19.0166L81.545 16.9313L76.2275 14.481L74.8199 8.06872L76.5924 4.99289L74.455 3.68958L74.1422 0.665878Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa);
export default __webpack_public_path__ + "static/media/IA.f124f2da974bd0a380423ec055d01d22.svg";
export { ForwardRef as ReactComponent };